import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { inject, observer } from 'mobx-react'
import Countdown from 'react-countdown-now';
import { Card, Menu, Icon, Steps, message, Dropdown, Popconfirm, Tooltip } from 'antd'
import { getRegistered } from '../../contract/Oracles';
import Modal from 'react-modal'
import PropBets from './PropBets'
import StepOne from '../layoutComponents/betSteps/StepOne'
import StepTwo from '../layoutComponents/betSteps/StepTwo'
import StepThree from '../layoutComponents/betSteps/StepThree'
import StepFour from '../layoutComponents/betSteps/StepFour'
import CreatorName from '../layoutComponents/CreatorName'
import { cancelEvent as cancelApiEvent } from '../../api-calls/events'
import { cancelEvent as cancelContractEvent } from '../../contract/Events'
import { finalizeEvent as finalizeApiEvent } from '../../api-calls/events'
import { finalizeEvent as finalizeContractEvent } from '../../contract/Events'
import { takeWager as takeContractWager } from '../../contract/WagersController'
import { takeWager as takeWagerApi } from '../../api-calls/wagers'
import { registerOracle } from "../../contract/OraclesController"
import { registerOracle as registerOracleApi } from '../../api-calls/oracles'
import FollowTeamBtn from './followButtons/FollowTeamBtn';
import NavViews from '../../stores/NavViews';
import OraclePropBets from "../layoutComponents/OraclePropBets";
import { utils } from 'web3';
const SubMenu = Menu.SubMenu;
const mvuMultiplier = 100000;
const ethMultiplier = 1000000000000000000;
const roundingMultiplier = 1000000000;

@observer(["AuthStore", "ViewStore", "eventStore", "AdminStore", "WagerStore", "BetSlipStore", "web3Store", "CustomRouter", "UserStore", "TeamStore", "CategoriesStore"])
class SingleEventCard extends Component {
    constructor(props) {
        super(props);
        this.showCancelModal = this.showCancelModal.bind(this);
        this.handleCancelOk = this.handleCancelOk.bind(this);
        this.handleCancelCancel = this.handleCancelCancel.bind(this);
        this.onAdminMenuClick = this.onAdminMenuClick.bind(this);
        this.onTeamOneWagerSortingMenuClick = this.onTeamOneWagerSortingMenuClick.bind(this);
        this.onTeamTwoWagerSortingMenuClick = this.onTeamTwoWagerSortingMenuClick.bind(this);
        this.showFinalizeModal = this.showFinalizeModal.bind(this);
        this.handleFinalizeOk = this.handleFinalizeOk.bind(this);
        this.handleFinalizeCancel = this.handleFinalizeCancel.bind(this);
        this.showOracleModal = this.showOracleModal.bind(this);
        this.handleOracleOk = this.handleOracleOk.bind(this);
        this.handleOracleCancel = this.handleOracleCancel.bind(this);
        this.openBetModal = this.openBetModal.bind(this);
        this.afterOpenBetModal = this.afterOpenBetModal.bind(this);
        this.closeBetModal = this.closeBetModal.bind(this);
        this.renderTeamOneWagers = this.renderTeamOneWagers.bind(this);
        this.renderTeamTwoWagers = this.renderTeamTwoWagers.bind(this);
        this.addToBetSlip = this.addToBetSlip.bind(this);
        this.takeBet = this.takeBet.bind(this);
        this.setWagerRefresh = this.setWagerRefresh.bind(this);
        this.oracleTeamOneClicked = this.oracleTeamOneClicked.bind(this);
        this.oracleTeamTwoClicked = this.oracleTeamTwoClicked.bind(this);
        this.resetTeamOneWagerSort = this.resetTeamOneWagerSort.bind(this);
        this.resetTeamTwoWagerSort = this.resetTeamTwoWagerSort.bind(this);

        this.state = {
            betModalIsOpen: false,
            makerChoice: 0,
            current: 0,
            oracleStatus: false,
            loadingWagers: true,
            cancelModalVisible: false,
            finalizeModalVisible: false,
            oracleModalVisible: false,
            oracleOneBackground: "#041827",
            oracleTwoBackground: "#041827",
            chosenOracleTeam: null,
            oracleStake: 0,
            registered: false,
            teamOneLogo: "",
            teamTwoLogo: "",
            teamOneName: "",
            teamTwoName: "",
            teamOneAbbreviation: "",
            teamTwoAbbreviation: "",
            sortTeamOneWagersByValueAscending: false,
            sortTeamOneWagersByValueDescending: false,
            sortTeamOneWagersByOddsAscending: false,
            sortTeamOneWagersByOddsDescending: false,
            sortTeamOneWagersByPotentialWinAscending: false,
            sortTeamOneWagersByPotentialWinDescending: false,
            sortTeamTwoWagersByValueAscending: false,
            sortTeamTwoWagersByValueDescending: false,
            sortTeamTwoWagersByOddsAscending: false,
            sortTeamTwoWagersByOddsDescending: false,
            sortTeamTwoWagersByPotentialWinsAscending: false,
            sortTeamTwoWagersByPotentialWinDescending: false,
            loadingTeams: true,
            lastRefreshed: new Date().getTime(),
            backgroundPic: "",
            thisCategory: { _id: "", picUrls: [] }
        };
    }

    async componentWillMount() {
        const { AdminStore, ViewStore, TeamStore } = this.props;
        this.setState({ oracleStatus: AdminStore.getOracleStatus() }); // prompts the first retrieval

        TeamStore.queryTeams();
    }

    async componentDidMount() {
        const {
            event_id,
            bytes32_id,
            start_time,
            team_one,
            team_two,
            TeamStore,
            ViewStore,
            WagerStore,
            CategoriesStore,
            eventStore,
            AdminStore,
        } = this.props;

        //console.log("teams: " + JSON.stringify(TeamStore));
        AdminStore.getMinOracleStake();

        let self = this;
        getRegistered(bytes32_id).then((registered) => {
            self.setState({ registered });
        });

        let categoryList = [];
        CategoriesStore.queryCategories().then(async () => {
            setTimeout(() => {
                self.setState({ categories: Array.from(CategoriesStore.categories.values()) });
            }, 50)

        });

        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (team_one == team._id) {
                    self.setState({
                        teamOneLogo: team.logoUrl,
                        teamOneName: team.name,
                        teamOneAbbreviation: team.abbreviation
                    });
                }
                if (team_two == team._id) {
                    self.setState({
                        teamTwoLogo: team.logoUrl,
                        teamTwoName: team.name,
                        teamTwoAbbreviation: team.abbreviation
                    });
                }
            });
            // console.log("teams: " + JSON.stringify(TeamStore));

            ViewStore.changeView("EVENTS  /  " + this.state.teamOneName + " VS " + this.state.teamTwoName);
            CategoriesStore.categories.forEach((category) => { (category._id == eventStore.activeEvent.categoryId ? this.setState({ thisCategory: category }) : null) });
            this.setState({
                backgroundPic: this.state.thisCategory.picUrls[Math.floor(Math.random() * Math.floor(this.state.thisCategory.picUrls.length - 1))]
            });
        }
            , 130
        );
        setTimeout(() => { self.setState({ loadingTeams: false }) }, 100);
        this.setWagerRefresh()
    }

    componentWillUnmount() {

        clearInterval(this.state.refreshItervalId);
    }

    setWagerRefresh() {
        const {
            WagerStore,
            event_id

        } = this.props;
        let refreshItervalId = setInterval(() => {
            // console.log("refreshing wagers");
            WagerStore.queryEventWagers(event_id);
        }, 120000);
        this.setState({ refreshItervalId });
    }

    showCancelModal = () => {
        this.setState({
            cancelModalVisible: true,
        });
    }

    showFinalizeModal = () => {
        this.setState({
            finalizeModalVisible: true,
        });
    }
    showOracleModal = (teamChosen) => {
        if (this.props.AdminStore.oracleStatus) {
            this.setState({
                oracleModalVisible: true,
            });
            (teamChosen == 1 ? this.oracleTeamOneClicked() : this.oracleTeamTwoClicked());
        } else {
            message.warning("You are not verified as an Oracle.");
        }
    }

    handleCancelOk = (e) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore } = this.props;
        const { router: { params } } = CustomRouter;
        console.log(e);
        this.setState({
            cancelModalVisible: false,
        });
        let self = this;
        return cancelContractEvent(self.props.bytes32_id).then(function (result) {
            if (String(result).includes('User denied transaction signature')) {
                message.warning("Metamask transaction denied! Event not cancelled.");
            } else {
                return cancelApiEvent(AuthStore.userAuth.auth.accessToken,
                    self.props.bytes32_id).then(function () {
                        CustomRouter.router.goTo(NavViews.home)
                        return eventStore.queryEvents();
                    });
            }
        });
    }

    handleFinalizeOk = (e) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore } = this.props;
        const { router: { params } } = CustomRouter;
        console.log(e);
        this.setState({
            finalizeModalVisible: false,
        });
        let self = this;
        return finalizeContractEvent(self.props.bytes32_id).then(function (result) {
            if (String(result).includes('User denied transaction signature')) {
                message.warning("Metamask transaction denied! Event not finalized.");
            } else {
                return finalizeApiEvent(AuthStore.userAuth.auth.accessToken,
                    self.props.bytes32_id).then(function () {
                        CustomRouter.router.goTo(NavViews.expiredEvents)
                        return eventStore.queryEvents();
                    });
            }
        });
    }

    handleOracleOk = (e) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore, AdminStore, web3Store } = this.props;
        const { router: { params } } = CustomRouter;
        console.log(e);

        let self = this;


        if (this.state.chosenOracleTeam == null) {
            message.info("You must choose a winning team!");
        } else {
            if (this.state.oracleStake == 0 || isNaN(this.state.oracleStake)) {
                message.info("You must meet the minimum oracle stake which is " + AdminStore.minOracleStake + " MVU");
            } else {
                this.setState({
                    oracleModalVisible: false,
                });

                let eventBytes32Id = this.props.bytes32_id;
                let mvuStake = Number(this.state.oracleStake) * mvuMultiplier;
                let winnerVote = this.state.chosenOracleTeam;

                console.log("event ID " + self.props.event_id);
                console.log("bytes ID " + self.props.bytes32_id);
                console.log("stake " + mvuStake);
                console.log("vote " + winnerVote);
                registerOracle(eventBytes32Id, mvuStake, winnerVote).then(function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! Not registered as Oracle.");
                    } else {
                        return registerOracleApi(AuthStore.userAuth.auth.accessToken, eventBytes32Id, self.props.event_id, web3Store.account, mvuStake, winnerVote).then(() => {
                            console.log("registerOracleApi finished");

                        });
                    }

                });

            }
        }


    }

    handleCancelCancel = (e) => {
        console.log(e);
        this.setState({
            cancelModalVisible: false,
        });
    }

    handleFinalizeCancel = (e) => {
        console.log(e);
        this.setState({
            finalizeModalVisible: false,
        });
    }
    handleOracleCancel = (e) => {
        console.log(e);
        this.setState({
            oracleModalVisible: false,
        });
    }

    onAdminMenuClick(key) {
        const {
            event_id,
            bytes32_id,
            start_time,
            duration,
            team_one,
            team_two,
            teamOneWagers,
            teamTwoWagers,
            cancelled,
            finalized,
            drawWagers } = this.props;
        const { AdminStore } = this.props;


        console.log("key" + key.key);
        if (key.key == 3) {
            (cancelled ? message.info("This event has already been cancelled.") : this.showCancelModal());
        }
        let oraclePeriodEnded = (start_time + duration + Number(AdminStore.oraclePeriod) < new Date().getTime() / 1000);
        let eventEnded = (start_time + duration < new Date().getTime() / 1000);
        if (key.key == 2) {
            (eventEnded && !oraclePeriodEnded ? this.showOracleModal() : message.info("The current time is outside the oraclize period for this event"))
        }

        if (key.key == 1) {
            (oraclePeriodEnded ? (finalized ? message.info("This event has already been finalized.") : this.showFinalizeModal()) : message.info("The oracle period has not ended, you may not finalize yet."));
        }
    }

    onTeamOneWagerSortingMenuClick(key) {

        // console.log("key" + key.key);
        // console.log(this.state.sortTeamOneWagersByValueAscending)
        // console.log(this.state.sortTeamOneWagersByValueDescending)
        // console.log(this.state.sortTeamOneWagersByOddsAscending)
        // console.log(this.state.sortTeamOneWagersByOddsDescending)
        // console.log(this.state.sortTeamOneWagersByPotentialWinAscending)
        // console.log(this.state.sortTeamOneWagersByPotentialWinDescending)

        if (key.key == 1) {

            this.setState({
                sortTeamOneWagersByOddsAscending: false,
                sortTeamOneWagersByOddsDescending: false,
                sortTeamOneWagersByPotentialWinAscending: false,
                sortTeamOneWagersByPotentialWinDescending: false
            });

            if (!this.state.sortTeamOneWagersByValueAscending && !this.state.sortTeamOneWagersByValueDescending) {
                this.setState({ sortTeamOneWagersByValueDescending: true });
            }

            if (this.state.sortTeamOneWagersByValueAscending && !this.state.sortTeamOneWagersByValueDescending) {
                this.setState({ sortTeamOneWagersByValueAscending: false });
                this.setState({ sortTeamOneWagersByValueDescending: true });
            }

            if (!this.state.sortTeamOneWagersByValueAscending && this.state.sortTeamOneWagersByValueDescending) {
                this.setState({ sortTeamOneWagersByValueAscending: true });
                this.setState({ sortTeamOneWagersByValueDescending: false });
            }
        }

        if (key.key == 2) {

            this.setState({
                sortTeamOneWagersByValueAscending: false,
                sortTeamOneWagersByValueDescending: false,
                sortTeamOneWagersByPotentialWinAscending: false,
                sortTeamOneWagersByPotentialWinDescending: false
            });

            if (!this.state.sortTeamOneWagersByOddsAscending && !this.state.sortTeamOneWagersByOddsDescending) {
                this.setState({ sortTeamOneWagersByOddsDescending: true });
            }
            if (this.state.sortTeamOneWagersByOddsAscending && !this.state.sortTeamOneWagersByOddsDescending) {
                this.setState({ sortTeamOneWagersByOddsAscending: false });
                this.setState({ sortTeamOneWagersByOddsDescending: true });
            }
            if (!this.state.sortTeamOneWagersByOddsAscending && this.state.sortTeamOneWagersByOddsDescending) {
                this.setState({ sortTeamOneWagersByOddsAscending: true });
                this.setState({ sortTeamOneWagersByOddsDescending: false });
            }
        }

        if (key.key == 3) {

            this.setState({
                sortTeamOneWagersByValueAscending: false,
                sortTeamOneWagersByValueDescending: false,
                sortTeamOneWagersByOddsAscending: false,
                sortTeamOneWagersByOddsDescending: false
            });

            if (!this.state.sortTeamOneWagersByPotentialWinAscending && !this.state.sortTeamOneWagersByPotentialWinDescending) {
                this.setState({ sortTeamOneWagersByPotentialWinDescending: true });
            }

            if (this.state.sortTeamOneWagersByPotentialWinAscending && !this.state.sortTeamOneWagersByPotentialWinDescending) {
                this.setState({ sortTeamOneWagersByPotentialWinAscending: false });
                this.setState({ sortTeamOneWagersByPotentialWinDescending: true });
            }

            if (!this.state.sortTeamOneWagersByPotentialWinAscending && this.state.sortTeamOneWagersByPotentialWinDescending) {
                this.setState({ sortTeamOneWagersByPotentialWinAscending: true });
                this.setState({ sortTeamOneWagersByPotentialWinDescending: false });
            }
        }
    }


    onTeamTwoWagerSortingMenuClick(key) {

        // console.log("key" + key.key);
        // console.log(this.state.sortTeamTwoWagersByValueAscending)
        // console.log(this.state.sortTeamTwoWagersByValueDescending)
        // console.log(this.state.sortTeamTwoWagersByOddsAscending)
        // console.log(this.state.sortTeamTwoWagersByOddsDescending)
        // console.log(this.state.sortTeamTwoWagersByPotentialWinsAscending)
        // console.log(this.state.sortTeamTwoWagersByPotentialWinDescending)

        if (key.key == 1) {

            this.setState({
                sortTeamTwoWagersByOddsAscending: false,
                sortTeamTwoWagersByOddsDescending: false,
                sortTeamTwoWagersByPotentialWinAscending: false,
                sortTeamTwoWagersByPotentialWinDescending: false
            });

            if (!this.state.sortTeamTwoWagersByValueAscending && !this.state.sortTeamTwoWagersByValueDescending) {
                this.setState({ sortTeamTwoWagersByValueDescending: true });
            }

            if (this.state.sortTeamTwoWagersByValueAscending && !this.state.sortTeamTwoWagersByValueDescending) {
                this.setState({ sortTeamTwoWagersByValueAscending: false });
                this.setState({ sortTeamTwoWagersByValueDescending: true });
            }

            if (!this.state.sortTeamTwoWagersByValueAscending && this.state.sortTeamTwoWagersByValueDescending) {
                this.setState({ sortTeamTwoWagersByValueAscending: true });
                this.setState({ sortTeamTwoWagersByValueDescending: false });
            }
        }

        if (key.key == 2) {

            this.setState({
                sortTeamTwoWagersByValueAscending: false,
                sortTeamTwoWagersByValueDescending: false,
                sortTeamTwoWagersByPotentialWinAscending: false,
                sortTeamTwoWagersByPotentialWinDescending: false
            });

            if (!this.state.sortTeamTwoWagersByOddsAscending && !this.state.sortTeamTwoWagersByOddsDescending) {
                this.setState({ sortTeamTwoWagersByOddsDescending: true });
            }
            if (this.state.sortTeamTwoWagersByOddsAscending && !this.state.sortTeamTwoWagersByOddsDescending) {
                this.setState({ sortTeamTwoWagersByOddsAscending: false });
                this.setState({ sortTeamTwoWagersByOddsDescending: true });
            }
            if (!this.state.sortTeamTwoWagersByOddsAscending && this.state.sortTeamTwoWagersByOddsDescending) {
                this.setState({ sortTeamTwoWagersByOddsAscending: true });
                this.setState({ sortTeamTwoWagersByOddsDescending: false });
            }
        }

        if (key.key == 3) {

            this.setState({
                sortTeamTwoWagersByValueAscending: false,
                sortTeamTwoWagersByValueDescending: false,
                sortTeamTwoWagersByOddsAscending: false,
                sortTeamTwoWagersByOddsDescending: false
            });

            if (!this.state.sortTeamTwoWagersByPotentialWinAscending && !this.state.sortTeamTwoWagersByPotentialWinDescending) {
                this.setState({ sortTeamTwoWagersByPotentialWinDescending: true });
            }

            if (this.state.sortTeamTwoWagersByPotentialWinAscending && !this.state.sortTeamTwoWagersByPotentialWinDescending) {
                this.setState({ sortTeamTwoWagersByPotentialWinAscending: false });
                this.setState({ sortTeamTwoWagersByPotentialWinDescending: true });
            }

            if (!this.state.sortTeamTwoWagersByPotentialWinAscending && this.state.sortTeamTwoWagersByPotentialWinDescending) {
                this.setState({ sortTeamTwoWagersByPotentialWinAscending: true });
                this.setState({ sortTeamTwoWagersByPotentialWinDescending: false });
            }
        }
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    // Make Bet Modal

    openBetModal(team) {
        this.setState({ makerChoice: team, betModalIsOpen: true });
        // console.log('You are betting for: ' + team);
    }

    afterOpenBetModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeBetModal() {
        this.setState({ betModalIsOpen: false });
    }
    renderWager(wager, team) {
        const { AuthStore } = this.props;
        let potentialWin;

        if (wager.odds > 99) {
            potentialWin = wager.value / (wager.odds / 100);
        } else {
            potentialWin = wager.value * Math.floor(100 / wager.odds);

        }
        let selectedTeamName = "";
        let selectedTeamColor = "";
        let selectedTeamLogo = "";


        let rightOrLeft = ""
        if (team == 2) {
            selectedTeamName = this.state.teamOneName;
            selectedTeamColor = this.props.teamOneColor;
            selectedTeamLogo = this.state.teamOneLogo;
            rightOrLeft = "left";
        } else {
            selectedTeamName = this.state.teamTwoName;
            selectedTeamColor = this.props.teamTwoColor;
            selectedTeamLogo = this.state.teamTwoLogo;
            rightOrLeft = "top";
        }

        let popTitle = <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div><img src={selectedTeamLogo} width="75" /></div>
                <div style={{ padding: '2px 0px 0px 6px' }}>You are betting for <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: selectedTeamColor }}>{selectedTeamName}</strong> to win</div>
            </div>
            <div>You are <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: "#FFF" }}>betting {(potentialWin / ethMultiplier).toFixed(4)} ETH to win {(wager.value / ethMultiplier).toFixed(4)} ETH</strong></div>
        </div>
        let takeBetButton =
            <Popconfirm placement={rightOrLeft} title={popTitle} onConfirm={() => { message.warning("You must be logged in to take bets!") }} okText="Confirm" cancelText="Cancel">
                <button className="custom-btn-primary">Take Bet</button>
            </Popconfirm>
        if (AuthStore.userAuth.auth) {
            takeBetButton =
                <Popconfirm placement={rightOrLeft} title={popTitle} onConfirm={this.takeBet.bind(this, wager)} okText="Confirm" cancelText="Cancel">
                    <button className="custom-btn-primary">Take Bet</button>
                </Popconfirm>
        }
        return (
            <div className="single-event-page-card-wagers-component-wager" key={wager._id}>
                <div className="single-event-page-card-wagers-component-wager-details">
                    <div>Potential Win: <span style={{ fontWeight: '400' }}>{(Math.round(wager.value * roundingMultiplier) / roundingMultiplier / ethMultiplier).toFixed(4)} ETH</span></div>
                    <div>Odds: <span style={{ fontWeight: '400' }}>{wager.odds / 100} : 1</span></div>
                    <div>Creator: <CreatorName userId={wager.maker} /></div>
                    <div>To Take: <span style={{ fontWeight: '600' }}>{(Math.round(potentialWin * roundingMultiplier) / roundingMultiplier / ethMultiplier).toFixed(4)} ETH</span></div>
                </div>
                <div className="single-event-page-card-wagers-component-take-btn">
                    {takeBetButton}
                </div>
            </div>
        );
    }

    sortAscending(a, b) {
        if (a.value > b.value)
            return -1;
        if (a.value < b.value)
            return 1;
        return 0;
    }

    sortWagersDescending(a, b) {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    }

    resetTeamOneWagerSort() {
        this.setState({
            sortTeamOneWagersByValueAscending: false,
            sortTeamOneWagersByValueDescending: false,
            sortTeamOneWagersByOddsAscending: false,
            sortTeamOneWagersByOddsDescending: false,
            sortTeamOneWagersByPotentialWinAscending: false,
            sortTeamOneWagersByPotentialWinDescending: false
        });
    }

    resetTeamTwoWagerSort() {
        this.setState({
            sortTeamTwoWagersByValueAscending: false,
            sortTeamTwoWagersByValueDescending: false,
            sortTeamTwoWagersByOddsAscending: false,
            sortTeamTwoWagersByOddsDescending: false,
            sortTeamTwoWagersByPotentialWinsAscending: false,
            sortTeamTwoWagersByPotentialWinDescending: false
        })
    }

    renderTeamOneWagers() {
        const { teamOneWagers, WagerStore } = this.props;
        let wagerList = [];

        let wagersArray = Array.from(WagerStore.teamOneWagers.values());

        if (this.state.sortTeamOneWagersByValueAscending) {
            wagersArray.sort((a, b) => a.value - b.value);
        }
        else if (this.state.sortTeamOneWagersByValueDescending) {
            wagersArray.sort((a, b) => b.value - a.value);
        }
        else if (this.state.sortTeamOneWagersByOddsAscending) {
            wagersArray.sort((a, b) => a.odds - b.odds);
        }
        else if (this.state.sortTeamOneWagersByOddsDescending) {
            wagersArray.sort((a, b) => b.odds - a.odds);
        }
        else if (this.state.sortTeamOneWagersByPotentialWinAscending) {
            wagersArray.sort((a, b) => (a.value * a.odds) - (b.value * b.odds));
        }
        else if (this.state.sortTeamOneWagersByPotentialWinDescending) {
            wagersArray.sort((a, b) => (b.value * b.odds) - (a.value * a.odds));
        }

        for (let wager of wagersArray) {
            wagerList.push(this.renderWager(wager, 1));
        }
        return wagerList;
    }

    renderTeamTwoWagers() {
        const { teamTwoWagers, WagerStore } = this.props;
        let wagerList = [];

        let wagersArray = Array.from(WagerStore.teamTwoWagers.values());

        if (this.state.sortTeamTwoWagersByValueAscending) {
            wagersArray.sort((a, b) => a.value - b.value);
        }
        else if (this.state.sortTeamTwoWagersByValueDescending) {
            wagersArray.sort((a, b) => b.value - a.value);
        }
        else if (this.state.sortTeamTwoWagersByOddsAscending) {
            wagersArray.sort((a, b) => a.odds - b.odds);
        }
        else if (this.state.sortTeamTwoWagersByOddsDescending) {
            wagersArray.sort((a, b) => b.odds - a.odds);
        }
        else if (this.state.sortTeamTwoWagersByPotentialWinAscending) {
            wagersArray.sort((a, b) => (a.value * a.odds) - (b.value * b.odds));
        }
        else if (this.state.sortTeamTwoWagersByPotentialWinDescending) {
            wagersArray.sort((a, b) => (b.value * b.odds) - (a.value * a.odds));
        }

        for (let wager of wagersArray) {
            wagerList.push(this.renderWager(wager, 2));
        }
        return wagerList;
    }

    renderDrawWagers() {
        const { drawWagers, WagerStore } = this.props;
        let wagerList = [];
        for (let wager of WagerStore.drawWagers.values()) {
            wagerList.push(this.renderWager(wager, 0));
        }
        return wagerList;
    }

    addToBetSlip(teamChoice) {
        const { BetSlipStore, web3Store } = this.props;
        const {
            bytes32_id,
            event_id,
            start_time,
            team_one,
            team_two,
            duration
        } = this.props;

        // let team_one = this.state.teamOneName;
        // let team_two = this.state.teamTwoName;

        let selectedTeam = "";
        if (teamChoice == 1) {
            selectedTeam = team_one;
        }
        if (teamChoice == 2) {
            selectedTeam = team_two;
        }
        if (teamChoice == 0) {
            selectedTeam = "Draw";
        }

        const wagerBytes32Id = utils.sha3(selectedTeam + event_id + teamChoice + (+Date.now()));
        console.log(wagerBytes32Id)
        BetSlipStore.WagerList.add({
            bytes32Id: wagerBytes32Id,
            eventId: event_id,
            eventBytes32Id: bytes32_id,
            maker: web3Store.account,
            value: 50000000000000000,
            odds: 100,
            makerChoice: teamChoice,
            settled: false,
            cancelled: false,
            selectedTeam: selectedTeam,
            team_one: team_one,
            team_two: team_two,
            eventStartTime: start_time,
            eventDuration: duration,
            isPropWager: false,
            originalEventId: "",
            isPrivate: false
        });
    }



    takeBet(wager) {
        const {
            event_id,
            bytes32_id,
            start_time,
            duration } = this.props;
        const ethMultiplier = 1000000000000000000;
        const { BetSlipStore, web3Store, AuthStore, UserStore, WagerStore } = this.props;
        let token = AuthStore.userAuth.auth.accessToken;
        let amountToTake;

        if (wager.odds > 99) {
            amountToTake = (wager.value) / (wager.odds / 100);
            // console.log("this one");
        } else {
            amountToTake = (wager.value) * (Math.floor(100 / wager.odds));

        }
        // console.log("floor " + Math.floor(100 / wager.odds));
        console.log("Amount to take " + amountToTake);

        //console.log("wager to take " + JSON.stringify(wager));
        //console.log("endTime" + start_time+duration);
        if (Date.now() > (start_time + duration) * 1000) {
            message.info("You can't take bets, the event has finished.");
        } else {
            // console.log("wager.odds " + wager.odds);
            // console.log("wager.value " + wager.value);
            //  console.log(wager.value / (wager.odds / 100));
            //  console.log("DIV -- " + Math.floor((wager.value * ethMultiplier) / Math.floor(wager.odds / 100)));
            takeContractWager(wager.bytes32Id, amountToTake).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)

                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! No bet made.");
                    } else {
                        return takeWagerApi(token,
                            UserStore.user._id,
                            wager._id,
                            wager.bytes32Id,
                            amountToTake,
                            web3Store.account,
                            wager.eventId,
                            wager.makerChoice).then(function () {
                                WagerStore.queryEventWagers(wager.eventId);
                                return UserStore.updateUser(token);
                            });
                    }

                });
        }



    }

    oracleTeamOneClicked() {
        this.setState({
            oracleTwoBackground: "#041827",
            oracleOneBackground: "#1890ff",
            chosenOracleTeam: 1
        });

    }

    oracleTeamTwoClicked() {
        this.setState({
            oracleOneBackground: "#041827",
            oracleTwoBackground: "#1890ff",
            chosenOracleTeam: 2
        });
    }




    render() {
        const {
            event,
            event_id,
            bytes32_id,
            start_time,
            drawPossible,
            duration,
            teamOneWagers,
            teamTwoWagers,
            drawWagers,
            AdminStore,
            betsForTeamOne,
            betsForTeamTwo,
            amountBetForOne,
            amountBetForTwo } = this.props;

        let team_one = this.state.teamOneName;
        let team_two = this.state.teamTwoName;

        const { WagerStore } = this.props;
        let betsForOneDonutData = 0;
        let betsForTwoDonutData = 0;
        let teamOneGraphData;
        let teamTwoGraphData;

        if (betsForTeamOne == 0 && betsForTeamTwo == 0) {
            betsForOneDonutData = 1;
            betsForTwoDonutData = 1;
            teamOneGraphData = 50 / 100;

            teamTwoGraphData = 50 / 100;
        } else if (betsForTeamOne > 0 && betsForTeamTwo == 0) {
            betsForOneDonutData = amountBetForOne;
            betsForTwoDonutData = amountBetForTwo;
            teamOneGraphData = 1;
            teamTwoGraphData = 0;
        } else if (betsForTeamOne == 0 && betsForTeamTwo > 0) {
            betsForOneDonutData = amountBetForOne;
            betsForTwoDonutData = amountBetForTwo;
            teamTwoGraphData = 1;
            teamOneGraphData = 0;

        } else {
            betsForOneDonutData = amountBetForOne;
            betsForTwoDonutData = amountBetForTwo;
            teamOneGraphData = amountBetForOne / (amountBetForOne + amountBetForTwo);
            teamTwoGraphData = amountBetForTwo / (amountBetForOne + amountBetForTwo);

        }


        const DoughnutData = {
            labels: [
                (amountBetForTwo / ethMultiplier).toFixed(2) + " on " + this.state.teamTwoAbbreviation.toUpperCase() + "         ",// + " - " + team_two.slice(0, 2),// team_two,
                //'Draw',
                (amountBetForOne / ethMultiplier).toFixed(2) + " on " + this.state.teamOneAbbreviation.toUpperCase() + "         ",//team_one,
            ],
            datasets: [{
                data: [betsForTwoDonutData, betsForOneDonutData],
                backgroundColor: [
                    this.props.teamTwoColor,
                    this.props.teamOneColor,
                    //  '#2e693f',
                ],
                hoverBackgroundColor: [
                    this.props.teamTwoColor,
                    this.props.teamOneColor,
                    // '#2e693f',
                ],
                borderColor: [
                    'rgba(255, 255, 255, 0)',
                    'rgba(255, 255, 255, 0)',
                    // 'rgba(255, 255, 255, 0)',
                ],
            }]
        };

        const { CustomRouter, UserStore } = this.props;
        const { router: { goTo } } = CustomRouter;
        const menu = <Menu
            // defaultSelectedKeys={['1']}
            onClick={this.onAdminMenuClick}
            defaultOpenKeys={['sub1']}
            theme="dark"
        >
            <Menu.Item key={1}>
                <Icon type="clock-circle" />
                <span>Finalize Event</span>
            </Menu.Item>
            {/* <Menu.Item key={2}>
                <Icon type="audit" />
                <span>Submit Oracle Vote</span>
            </Menu.Item> */}
            <Menu.Item key={3}>
                <Icon type="stop" />
                <span>Cancel Event</span>
            </Menu.Item>
            {/* <SubMenu key="sub1" title={<span><Icon type="mail" /><span>Navigation One</span></span>}>
            <Menu.Item key="5">Option 5</Menu.Item>
            <Menu.Item key="6">Option 6</Menu.Item>
            <Menu.Item key="7">Option 7</Menu.Item>
            <Menu.Item key="8">Option 8</Menu.Item>
        </SubMenu>
        <SubMenu key="sub2" title={<span><Icon type="appstore" /><span>Navigation Two</span></span>}>
            <Menu.Item key="9">Option 9</Menu.Item>
            <Menu.Item key="10">Option 10</Menu.Item>
            <SubMenu key="sub3" title="Submenu">
                <Menu.Item key="11">Option 11</Menu.Item>
                <Menu.Item key="12">Option 12</Menu.Item>
            </SubMenu>
        </SubMenu> */}
        </Menu>;

        const adminMenu = <Dropdown overlay={menu}>
            <button className="custom-btn-primary">
                Admin Actions <Icon type="down" />
            </button>
        </Dropdown>;

        const doubleCheckCancelModal = <Modal
            isOpen={this.state.cancelModalVisible}
            onRequestClose={this.handleCancelCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >
            <h2>Are you sure?</h2>
            <p>Are you certain you want to cancel this event? This cannot be undone.</p>
            <button onClick={this.handleCancelCancel} className="custom-btn-success">Exit</button> <button onClick={this.handleCancelOk} className="custom-btn-danger">Cancel Event</button>
        </Modal>

        const doubleCheckFinalizeModal = <Modal
            isOpen={this.state.finalizeModalVisible}
            onRequestClose={this.handleFinalizeCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >
            <h2>Are you sure?</h2>
            <p>Are you certain you want to finalize this event? This cannot be undone.</p>
            <button onClick={this.handleFinalizeCancel} className="custom-btn-success">Exit</button> <button onClick={this.handleFinalizeOk} className="custom-btn-danger">Finalize Event</button>
        </Modal>

        const oracleModal = <Modal
            isOpen={this.state.oracleModalVisible}
            onRequestClose={this.handleOracleCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >


            <h3 className="single-event-oracle-titles">Who won the game?</h3>
            <div style={{ textAlign: "center", display: "flex", flexDirection: "row", padding: "30px" }}>
                <Card onClick={this.oracleTeamOneClicked} bordered={false} style={{ background: this.state.oracleOneBackground, width: 300, padding: "30px" }}>
                    <h2 onClick={() => goTo(NavViews.team, { teamID: this.props.event.teams[0] }, CustomRouter)} className="single-event-oracle-subtitles">{team_one}</h2>
                    <img width="150px" height="72px" src={this.state.teamOneLogo} />
                </Card>
                <Card onClick={this.oracleTeamTwoClicked} bordered={false} style={{ background: this.state.oracleTwoBackground, width: 300, padding: "30px" }}>
                    <h2 onClick={() => goTo(NavViews.team, { teamID: this.props.event.teams[1] }, CustomRouter)} className="single-event-oracle-subtitles">{team_two}</h2>
                    <img width="150px" height="72px" src={this.state.teamTwoLogo} />
                </Card>
            </div>
            <h3 className="single-event-oracle-titles">How much will you stake?</h3>
            <input onChange={(event) => {
                this.setState({ oracleStake: Number(event.target.value) })
            }} placeholder="1.000 MVU" />
            <br />
            <br />
            <button onClick={this.handleOracleCancel} className="custom-btn-danger">Exit</button>
            <button onClick={this.handleOracleOk} className="custom-btn-success">Submit</button>
        </Modal>

        const { current } = this.state;
        const Step = Steps.Step;

        const steps = [{
            title: 'Select Bet Amount & Odds',
            content: <StepOne
                eventId={event_id}
                eventBytes32Id={bytes32_id}
                team_one={team_one}
                team_two={team_two}
                makerChoice={this.state.makerChoice}
                closeBetModal={this.closeBetModal}
            />,
            icon: 'bank',
        }];

        const makeBetModal = <Modal
            isOpen={this.state.betModalIsOpen}
            onAfterOpen={this.afterOpenBetModal}
            onRequestClose={this.closeBetModal}
            className="new-bet-modal"
            overlayClassName="new-bet-modal-overlay"
        >
            <div className="modal-close-btn" onClick={this.closeBetModal}><Icon type="close-circle" /></div>
            <Steps current={current} style={{ margin: '0 0 20px 0', padding: '32px 25px 25px 25px', background: 'rgba(0, 0, 0, 0.16)' }}>
                {steps.map(item => <Step icon={<Icon type={item.icon} />} key={item.title} title={item.title} />)}
            </Steps>
            <div className="steps-content" style={{ margin: '0 0 20px 0', padding: '25px', background: 'rgba(0, 0, 0, 0.16)', minHeight: '50vh' }}>{steps[current].content}</div>

        </Modal>

        let teamOneWagerLength = <Icon type="loading" />;
        let teamTwoWagerLength = <Icon type="loading" />;
        let drawWagerLength = <Icon type="loading" />;
        let teamOneWagersComponent = <div style={{ textAlign: 'center', marginTop: '25px', fontSize: '26px' }}><Icon type="loading" /></div>;
        let teamTwoWagersComponent = <div style={{ textAlign: 'center', marginTop: '25px', fontSize: '26px' }}><Icon type="loading" /></div>;

        if (!WagerStore.loading) {
            teamOneWagersComponent = this.renderTeamOneWagers();
            teamTwoWagersComponent = this.renderTeamTwoWagers();

            teamOneWagerLength = teamOneWagers.size + " ETH BET";
            teamTwoWagerLength = teamTwoWagers.size + " ETH BET";
            drawWagerLength = drawWagers.size + " ETH BET";
        }

        let startTime = new Date();
        startTime.setTime(start_time * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        let drawButton = "";

        if (drawPossible) {
            drawButton = <button onClick={() => this.addToBetSlip(0)} className="single-event-page-cards-options-draw">
                <span className="single-event-page-cards-bet-options-title">DRAW</span>
                {/* <div className="single-event-page-cards-bets-amount">{drawWagerLength}</div> */}
            </button>
        }

        let backgroundImgUrl = this.state.backgroundPic;

        let gridTemplateColumnsPercentage = String(teamOneGraphData * 100) + "%" + String(teamTwoGraphData * 100) + "%";

        return (
            <div>
                < div className="single-event-admin-menu" >
                    {doubleCheckCancelModal}
                    {doubleCheckFinalizeModal}
                    {makeBetModal}
                    {oracleModal}
                    {(UserStore.user.role === "admin" ? adminMenu : null)}
                </div >
                {this.state.registered ? <span style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }}><Icon type="safety" style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }} theme="outlined" /> REGISTERED</span> :
                    (Date.now() / 1000 > start_time + duration ? <span style={{ fontSize: '16px', color: '#e0e018' }}><Icon type="warning" style={{ fontSize: '16px', color: '#e0e018' }} theme="outlined" /> NOT REGISTERED</span> : "")}
                <div style={{ backgroundImage: `url(${backgroundImgUrl})` }} className="single-event-page-rows-teams">
                    <div className="single-event-page-rows-teams-teamone">
                        {/* <Tooltip title="View Team Info" onClick={() => goTo(NavViews.team, { teamID: this.props.team_one }, CustomRouter)}> */}
                        <span 
                        //style={{ cursor: 'pointer' }}
                        //  onClick={() => goTo(NavViews.team, { teamID: this.props.team_one }, CustomRouter)}
                        ><img src={this.state.teamOneLogo} width="90px" /></span>
                        <div 
                        //style={{ cursor: 'pointer' }}
                        // onClick={() => goTo(NavViews.team, { teamID: this.props.team_one }, CustomRouter)}
                        >{team_one}</div>
                        {/* </Tooltip> */}
                        <div style={{ marginTop: '7px' }}><FollowTeamBtn teamId={this.props.team_one} /></div>
                    </div>
                    <div className="single-event-page-rows-teams-vs">
                        <div style={{ marginTop: '-10px' }}>
                            {!this.state.loadingTeams ? <Doughnut
                                legend={null}
                                width={110}
                                options={{
                                    maintainAspectRatio: false
                                }}
                                height={55}
                                data={DoughnutData}
                            /> : <Icon style={{ fontSize: '62px', color: '#1890ff', padding: '10px' }} type="loading" />}
                        </div>
                        ETH BET
                    </div>
                    <div className="single-event-page-rows-teams-teamtwo">
                        {/* <Tooltip title="View Team Info" onClick={() => goTo(NavViews.team, { teamID: this.props.team_two }, CustomRouter)}> */}
                        <span 
                     //   style={{ cursor: 'pointer' }}
                        //  onClick={() => goTo(NavViews.team, { teamID: this.props.team_two }, CustomRouter)}
                        ><img src={this.state.teamTwoLogo} width="90px" /></span>
                        <div
                    //     style={{ cursor: 'pointer' }}
                        // onClick={() => goTo(NavViews.team, { teamID: this.props.team_two }, CustomRouter)}
                        >{team_two}</div>
                        {/* </Tooltip> */}
                        <div style={{ marginTop: '7px' }}><FollowTeamBtn teamId={this.props.team_two} /></div>
                    </div>
                </div>
                <div className={"single-event-page-cards-" + (Date.now() / 1000 > start_time + duration + Number(AdminStore.oraclePeriod) ?
                    "expired" : (Date.now() / 1000 > start_time + duration ? "oracles" : "open"))}>
                    <div className="graph-lines-wrapper">
                        {teamOneGraphData == 0 || teamTwoGraphData == 0 ?
                            (teamOneGraphData > 0 ? <div className="graph-lines">
                                <svg className="firstLine" height={10} width={"50%"}>
                                    <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: this.props.teamOneColor, strokeWidth: 6 }} />
                                </svg>
                                <svg className="secondLine" height={10} width={"50%"}>
                                    <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: this.props.teamOneColor, strokeWidth: 6 }} />
                                </svg>
                            </div> :
                                <div className="graph-lines">
                                    <svg className="firstLine" height={10} width={"50%"}>
                                        <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: this.props.teamTwoColor, strokeWidth: 6 }} />
                                    </svg>
                                    <svg className="secondLine" height={10} width={"50%"}>
                                        <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: this.props.teamTwoColor, strokeWidth: 6 }} />
                                    </svg>
                                </div>
                            ) :
                            <div className="graph-lines">
                                <div style={{ display: 'grid', gridTemplateColumns: gridTemplateColumnsPercentage, height: '7px' }}>
                                    <div style={{ background: this.props.teamOneColor }} ></div>
                                    <div style={{ background: this.props.teamTwoColor }} ></div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="single-event-page-cards-event-info">
                        <div>{startTimeString}</div>
                    </div>
                    {
                        Date.now() / 1000 > start_time + duration ?

                            (Date.now() / 1000 > start_time + duration + Number(AdminStore.oraclePeriod) ? <div></div> : <div className="single-event-page-cards-bet-options-pick-title">
                                <span>Which team won?</span>
                            </div>) :
                            <div className="single-event-page-cards-bet-options-pick-title">
                                <span>Create a new bet</span>
                            </div>
                    }
                    {
                        Date.now() / 1000 > start_time + duration ?
                            (Date.now() / 1000 > start_time + duration + Number(AdminStore.oraclePeriod) ? <div></div> :
                                <div className="single-event-page-cards-bet-options">
                                    <button onClick={() => this.showOracleModal(1)} className="single-event-page-cards-options-teamone">
                                        <span className="single-event-page-cards-bet-options-title"><small>STAKE THAT</small> <bold>{team_one}</bold> <small>WON</small></span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForOne} ETH BET</div> */}
                                    </button>
                                    {drawButton}
                                    <button onClick={() => this.showOracleModal(2)} className="single-event-page-cards-options-teamtwo">
                                        <span className="single-event-page-cards-bet-options-title"><small>STAKE THAT</small> <bold>{team_two}</bold> <small>WON</small></span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                    </button>
                                </div>) :
                            <div className="single-event-page-cards-bet-options">
                                <button onClick={() => this.addToBetSlip(1)} className="single-event-page-cards-options-teamone">
                                    <span className="single-event-page-cards-bet-options-title"><small>BET ON</small> <bold>{team_one}</bold> <small>TO WIN</small></span>
                                    {/* <div className="single-event-page-cards-bets-amount">{amountBetForOne} ETH BET</div> */}
                                </button>
                                {drawButton}
                                <button onClick={() => this.addToBetSlip(2)} className="single-event-page-cards-options-teamtwo">
                                    <span className="single-event-page-cards-bet-options-title"><small>BET ON</small> <bold>{team_two}</bold> <small>TO WIN</small></span>
                                    {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                </button>
                            </div>
                    }
                    {
                        Date.now() / 1000 > start_time + duration + Number(AdminStore.oraclePeriod) ?
                            <div className="single-event-page-cards-status">
                                <div style={{ padding: '14px 0px 0px 0px', color: '#f73527', textAlign: 'left', position: 'relative' }}>
                                    <div className="live-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Expired</span></div>
                            </div> : (Date.now() / 1000 > start_time + duration ?
                                <div className="single-event-page-cards-status">
                                    <div style={{ padding: '14px 0px 0px 0px', color: '#f48541', textAlign: 'left', position: 'relative' }}>
                                        <div className="oracle-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Oracle Period</span></div>
                                </div>
                                :
                                <div className="single-event-page-cards-status">
                                    <div className="single-event-page-cards-status-open-expired">
                                        <div style={{ padding: '14px 0px 0px 0px', color: '#27f727', textAlign: 'left', position: 'relative' }}>
                                            <div className="open-icon"></div><span style={{ display: 'inline-block', marginLeft: '20px' }}>Open</span>
                                        </div>

                                        <div className="single-event-page-cards-status-time-remaining">
                                            <Countdown zeroPadLength={2} date={new Date(start_time + duration).getTime() * 1000}>
                                                <span>ENDED, NO TIME</span>
                                            </Countdown>
                                            <span style={{ marginLeft: '5px' }}>REMAINING</span>
                                        </div>
                                    </div>
                                </div>
                            )
                    }
                </div>
                {
                    Date.now() / 1000 < start_time + duration ?
                        <div className="single-event-page-card-wagers">
                            <div className="single-event-page-card-wagers-title">Bets to be taken</div>
                            <div className="single-event-page-card-wagers-grid">
                                <div className="single-event-page-card-team-wagers">
                                    <div className="single-event-page-card-team-wagers-title">{team_one} to win</div>
                                    <div className="single-event-page-card-team-wagers-sort-options">
                                        <div className="single-event-page-card-team-wagers-sort-options-sort">
                                            <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                                            <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                Potential Win {this.state.sortTeamTwoWagersByValueAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamTwoWagersByValueDescending ? <Icon type="down" /> : null}
                                            </button>
                                            <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamTwoWagersByOddsAscending || this.state.sortTeamTwoWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                Odds {this.state.sortTeamTwoWagersByOddsAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamTwoWagersByOddsDescending ? <Icon type="down" /> : null}
                                            </button>
                                            <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamTwoWagersByPotentialWinAscending || this.state.sortTeamTwoWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                To Take {this.state.sortTeamTwoWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamTwoWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                                            </button>
                                        </div>
                                        <div className="single-event-page-card-team-wagers-sort-options-reset">
                                            {
                                                this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending || this.state.sortTeamTwoWagersByOddsAscending ||
                                                    this.state.sortTeamTwoWagersByOddsDescending || this.state.sortTeamTwoWagersByPotentialWinAscending ||
                                                    this.state.sortTeamTwoWagersByPotentialWinDescending ?
                                                    <button onClick={this.resetTeamTwoWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    <div className="single-event-page-card-wagers-component">
                                        {teamTwoWagersComponent}
                                    </div>

                                </div>
                                <div className="single-event-page-card-team-wagers">
                                    <div className="single-event-page-card-team-wagers-title">{team_two} to win</div>

                                    <div className="single-event-page-card-team-wagers-sort-options">
                                        <div className="single-event-page-card-team-wagers-sort-options-sort">
                                            <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                                            <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                Potential Win {this.state.sortTeamOneWagersByValueAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamOneWagersByValueDescending ? <Icon type="down" /> : null}
                                            </button>
                                            <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamOneWagersByOddsAscending || this.state.sortTeamOneWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                Odds {this.state.sortTeamOneWagersByOddsAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamOneWagersByOddsDescending ? <Icon type="down" /> : null}
                                            </button>
                                            <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamOneWagersByPotentialWinAscending || this.state.sortTeamOneWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                                                To Take {this.state.sortTeamOneWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                                                {this.state.sortTeamOneWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                                            </button>
                                        </div>
                                        <div className="single-event-page-card-team-wagers-sort-options-reset">
                                            {
                                                this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending || this.state.sortTeamOneWagersByOddsAscending ||
                                                    this.state.sortTeamOneWagersByOddsDescending || this.state.sortTeamOneWagersByPotentialWinAscending ||
                                                    this.state.sortTeamOneWagersByPotentialWinDescending ?
                                                    <button onClick={this.resetTeamOneWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    <div className="single-event-page-card-wagers-component">
                                        {teamOneWagersComponent}
                                    </div>
                                </div>
                            </div>
                            <PropBets originalEvent={event} eventId={event_id} relatedPropEvents={this.props.relatedPropEvents} />
                        </div>
                        //: null
                        : <OraclePropBets originalEvent={event} eventId={event_id} relatedPropEvents={this.props.relatedPropEvents} />
                }

            </div >
        );
    }
}
export default SingleEventCard;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/SingleEventCard.js